export default __webpack_public_path__ + "media/src/assets/images/blue_filled-9217dccba0f06b995760f976aa6793c0.png";